import {
  ExecuteCampaignV2Params,
  ExecuteCampaignV2Response,
  ExecuteCampaignV2SimplifiedParams,
  OyResponse,
  SubmitCampaignV2DataParams,
  SubmitCampaignV2DataResponse,
  SubmitCampaignV2MetaDataParams,
  SubmitCampaignV2MetaDataResponse,
} from '@oy/types';
import axios, {
  BULK_DISBURSE_PREFIX,
  BUSINESS_PAYMENT_PREFIX,
  decodedUriParamsSerializer,
} from 'src/clients/axios';
import {
  BulkGetReceiptParams,
  BulkReceiptSettingParams,
  BulkReceiptSettingResponse,
  BulkSendReceiptParams,
  CheckBulkReceiptProgessResponse,
  DownloadBulkDisbursementsParams,
  DownloadBulkDisbursementsResponse,
  PollingResultBulkValidationParams,
  PollingResultBulkValidationParamsV2,
  PollingResultBulkValidationParamsV3,
  PollingResultBulkValidationResponse,
  PollingResultBulkValidationResponseV2,
  PollingResultBulkValidationResponseV3,
  PublicRecipientVendorResponse,
  ReceiptMetadataResponse,
} from 'src/models';
import {
  BulkDeletionSyncRequestList,
  BulkValidationAsyncRequest,
  BulkValidationAsyncRequest2,
  BulkValidationSyncRequest2,
  ChangeAllNameList,
} from 'src/pages/Disbursement/Bulk/Create/types';
import {
  BulkDisbursementDetailListRq,
  BulkDisbursementDetailListRs,
} from 'src/pages/Disbursement/Bulk/types';

// Timeout: 60 s
export const postUploadCsv = (data: FormData) => {
  return axios({
    method: 'post',
    timeout: 60000,
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/create`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadCsv = (data: FormData) => {
  return axios({
    method: 'post',
    timeout: 60000,
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/upload-file`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getStatusCampaign = (params: any) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/search`,
    params,
    paramsSerializer: decodedUriParamsSerializer,
  });
};

export const downloadBulkDisbursements = (
  params: DownloadBulkDisbursementsParams,
) => {
  return axios.request<DownloadBulkDisbursementsResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/download`,
    params,
    paramsSerializer: decodedUriParamsSerializer,
  });
};

export const getCampaignDetail = (params: any) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/detail`,
    params,
    paramsSerializer: decodedUriParamsSerializer,
  });
};

export const getChildAccountCampaignDetail = (params: any) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/detail/child`,
    params,
    paramsSerializer: decodedUriParamsSerializer,
  });
};

export const getCampaignMembers = (params: any) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/member/search`,
    params,
    paramsSerializer: decodedUriParamsSerializer,
  });
};

export const getCampaignTransactionsAll = (
  params: BulkDisbursementDetailListRq,
) => {
  return axios.request<OyResponse<BulkDisbursementDetailListRs>>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/transaction/search`,
    params,
    paramsSerializer: decodedUriParamsSerializer,
  });
};

export const getChildStatusCampaign = (params: any) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/children/search`,
    params,
  });
};

export const downloadChildBulkDisbursements = (params: any) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/children/download`,
    params,
  });
};

export const retryFailedCampaign = (data: any) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/retry-failed`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const validateDataBulkDisbursementAsync = (
  data: BulkValidationAsyncRequest,
) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/validate-async`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const validateDataBulkDisbursementAsyncV2 = (
  data: BulkValidationAsyncRequest2,
) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/v2/validate-async`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const validateDataBulkDisbursementSync = (data: any) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/validate`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const validateDataBulkDisbursementSyncV2 = (
  data: BulkValidationSyncRequest2,
) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/v2/validate`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteDataBulkDisbursement = (
  data: BulkDeletionSyncRequestList,
) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/delete-member`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const changeNameBulkDisbursement = (data: ChangeAllNameList) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/change-name`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAdminFeeBulkPreCreation = () => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/creation-tier-pricing`,
  });
};

export const approve = (data: any) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/execute`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const rescheduleCampaign = (data: any) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/reschedule`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const postCancelCampaign = (data: any) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/cancel`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const pollingResultBulkValidation = (
  params: PollingResultBulkValidationParams,
) => {
  return axios.request<PollingResultBulkValidationResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/validate-async-result`,
    params,
  });
};

export const pollingResultBulkValidationV2 = (
  params: PollingResultBulkValidationParamsV2,
) => {
  return axios.request<PollingResultBulkValidationResponseV2>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/v2/validate-async-result`,
    params,
  });
};

export const pollingResultBulkValidationV3 = (
  params: PollingResultBulkValidationParamsV3,
) => {
  return axios.request<PollingResultBulkValidationResponseV3>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/v3/validate-async-result`,
    params,
  });
};

export const terminateValidation = (params: string) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/validate-async-terminate?request_id=${params}`,
  });
};

export const sendBulkReceiptAsync = (data: BulkSendReceiptParams) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/send-receipt-async`,
    data,
  });
};

export const getBulkReceipt = (params: BulkGetReceiptParams) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/get-bulk-receipt`,
    params,
  });
};

export const generateBulkReceipt = (campaignId: string) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/receipt/generate?id=${campaignId}`,
    disableToast: true,
  });
};

export const downloadBulkReceipt = (campaignId: string) => {
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/receipt/download?id=${campaignId}`,
    disableToast: true,
    responseType: 'blob',
  });
};

export const getReceiptMetadata = (campaignId: string) => {
  return axios.request<ReceiptMetadataResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/receipt/metadata?id=${campaignId}`,
    disableToast: true,
  });
};

export const checkReceiptProgress = (campaignId: string) => {
  return axios.request<CheckBulkReceiptProgessResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/receipt/status-generate?id=${campaignId}`,
    disableToast: true,
  });
};

export const getBulkReceiptConfig = () => {
  return axios.request<BulkReceiptSettingResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/bulk-receipt-config`,
  });
};

export const updateBulkReceiptConfig = (data: BulkReceiptSettingParams) => {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/bulk-receipt-config`,
    data,
  });
};

export const getPublicRecipientVendorList = () => {
  return axios.request<PublicRecipientVendorResponse>({
    method: 'get',
    url: `bank/v1/disbursement`,
  });
};

export const submitCampaignV2MetaData = (
  data: SubmitCampaignV2MetaDataParams,
) => {
  return axios.request<SubmitCampaignV2MetaDataResponse>({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/order-campaign`,
    data,
  });
};

export const submitCampaignV2Data = (data: SubmitCampaignV2DataParams) => {
  return axios.request<SubmitCampaignV2DataResponse>({
    method: 'put',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/order-campaign`,
    data,
  });
};

// Timeout: 60 s
export const executeCampaignV2 = (data: ExecuteCampaignV2Params) => {
  return axios.request<ExecuteCampaignV2Response>({
    method: 'put',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/send-instruction`,
    data,
    headers: {
      'X-Oy-Idempotency-Key': data.campaignId,
    },
    timeout: 60000,
  });
};

export const executeCampaignV2Simplified = (
  data: ExecuteCampaignV2SimplifiedParams,
) => {
  return axios.request<ExecuteCampaignV2Response>({
    method: 'put',
    url: `${BUSINESS_PAYMENT_PREFIX}${BULK_DISBURSE_PREFIX}/v2/send-instruction`,
    data,
    headers: {
      'X-Oy-Idempotency-Key': data.campaignId,
    },
    timeout: 60000,
    disableToast: true,
  });
};
